export enum PlayerRollCompetitionAwardsQueryKeys {
  Primary = 'player-roll-competition-awards',
}
